import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import HomePage from 'views/home/Home';
import NotFoundView from 'views/not-found';
import AboutPage from 'views/about/AboutPage';
import InfobookCssView from 'views/infobook/css/CssView';
import InfobookHtmlView from 'views/infobook/html/HtmlView';
import InfobookView from 'views/infobook/home/InfobookHome';
import InfobookJavaScriptView from 'views/infobook/javascript/JavaScriptView';
import InfobookTemplatesView from 'views/infobook/templates/InfobookTemplatesView';

const AppRoutes = () => {
  return (
    <section>
      <Routes>
        <Route exact path="/home" element={<HomePage />} />
        <Route exact path="/about" element={<AboutPage />} />
        <Route exact path="/infobook" element={<InfobookView />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route exact path="/infobook/html" element={<InfobookHtmlView />} />
        <Route exact path="/infobook/css" element={<InfobookCssView />} />
        <Route exact path="/infobook/javascript" element={<InfobookJavaScriptView />} />
        <Route exact path="/infobook/templates" element={<InfobookTemplatesView />} />
        <Route exact path="/*" element={<NotFoundView />} />
      </Routes>
    </section>
  );
};

export default AppRoutes;
